import { InputEntity } from "..";

export class UserValidationInput extends InputEntity {
  public constructor(public readonly message: string | null = null) {
    super();
  }
}
